import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarStateService {
  private sidebarExpandedSubject = new BehaviorSubject<boolean>(false);
  public sidebarExpanded$ = this.sidebarExpandedSubject.asObservable();

  private sidebarActiveSubject = new BehaviorSubject<boolean>(false);
  public sidebarActive$ = this.sidebarActiveSubject.asObservable();

  setSidebarExpanded(expanded: boolean): void {
    this.sidebarExpandedSubject.next(expanded);
  }

  get isSidebarExpanded(): boolean {
    return this.sidebarExpandedSubject.value;
  }

  setSidebarActive(active: boolean): void {
    this.sidebarActiveSubject.next(active);
  }

  get isSidebarActive(): boolean {
    return this.sidebarActiveSubject.value;
  }
}
